import React from 'react';

type Props = {
  fill?: string;
};

const CODPaymentIcon = ({ fill = 'var(--PRIMARY)' }: Props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 11V5" stroke={fill} strokeWidth="2" />
    <path d="M18 11V5" stroke={fill} strokeWidth="2" />
    <line x1="11" y1="10" x2="19" y2="10" stroke={fill} strokeWidth="2" />
    <path
      d="M27 8C27 6.93913 26.5786 5.92172 25.8284 5.17157C25.0783 4.42143 24.0609 4 23 4H7C5.93913 4 4.92172 4.42143 4.17157 5.17157C3.42143 5.92172 3 6.93913 3 8V24C3 25.0609 3.42143 26.0783 4.17157 26.8284C4.92172 27.5786 5.93913 28 7 28H12.5C12.5 27.3086 12.5 26.7656 12.5 26H7C6.46957 26 5.96086 25.7893 5.58579 25.4142C5.21071 25.0391 5 24.5304 5 24V11.3333H25V17C25.792 17 26.3973 17 27 17V8ZM7 6H23C23.5304 6 24.0391 6.21071 24.4142 6.58579C24.7893 6.96086 25 7.46957 25 8V11.3333H5V8C5 7.46957 5.21071 6.96086 5.58579 6.58579C5.96086 6.21071 6.46957 6 7 6Z"
      fill={fill}
    />
    <rect
      x="14"
      y="19"
      width="14"
      height="8"
      rx="1"
      stroke={fill}
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.835 26.67C22.953 26.67 24.67 24.953 24.67 22.835C24.67 20.717 22.953 19 20.835 19C18.717 19 17 20.717 17 22.835C17 24.953 18.717 26.67 20.835 26.67ZM19.108 20.975C19.1605 21.0276 19.2317 21.0571 19.306 21.0571H19.8661C20.1144 21.0571 20.3557 21.1396 20.5521 21.2917C20.7485 21.4437 20.8888 21.6567 20.9509 21.8972H19.306C19.2317 21.8972 19.1605 21.9267 19.108 21.9792C19.0554 22.0317 19.0259 22.1029 19.0259 22.1772C19.0259 22.2515 19.0554 22.3227 19.108 22.3752C19.1605 22.4278 19.2317 22.4573 19.306 22.4573H20.9509C20.8888 22.6977 20.7485 22.9107 20.5521 23.0628C20.3557 23.2148 20.1144 23.2973 19.8661 23.2974H19.3096C19.2688 23.2966 19.2282 23.3049 19.191 23.3217C19.1537 23.3384 19.1206 23.3632 19.094 23.3943C19.0494 23.4465 19.0252 23.5132 19.0259 23.5819C19.0264 23.6265 19.0377 23.6704 19.0587 23.7097C19.0798 23.7491 19.1101 23.7827 19.1469 23.8079L21.1036 25.2056C21.1335 25.2269 21.1674 25.2422 21.2032 25.2505C21.239 25.2588 21.2761 25.2599 21.3124 25.2539C21.3487 25.2478 21.3834 25.2347 21.4146 25.2152C21.4458 25.1957 21.4729 25.1703 21.4942 25.1403C21.5156 25.1104 21.5309 25.0765 21.5391 25.0407C21.5474 25.0049 21.5486 24.9678 21.5425 24.9315C21.5364 24.8952 21.5233 24.8605 21.5038 24.8293C21.4843 24.7981 21.4589 24.771 21.429 24.7497L20.1472 23.8339C20.491 23.7754 20.8081 23.6115 21.0546 23.3649C21.301 23.1182 21.4648 22.8011 21.5231 22.4573H22.3864C22.4607 22.4573 22.5319 22.4278 22.5845 22.3752C22.637 22.3227 22.6665 22.2515 22.6665 22.1772C22.6665 22.1029 22.637 22.0317 22.5845 21.9792C22.5319 21.9267 22.4607 21.8972 22.3864 21.8972H21.5231C21.4704 21.5845 21.3301 21.2931 21.1184 21.0571H22.3864C22.4607 21.0571 22.5319 21.0276 22.5845 20.975C22.637 20.9225 22.6665 20.8513 22.6665 20.777C22.6665 20.7027 22.637 20.6315 22.5845 20.579C22.5319 20.5265 22.4607 20.497 22.3864 20.497H19.306C19.2317 20.497 19.1605 20.5265 19.108 20.579C19.0554 20.6315 19.0259 20.7027 19.0259 20.777C19.0259 20.8513 19.0554 20.9225 19.108 20.975Z"
      fill={fill}
    />
  </svg>
);

export default CODPaymentIcon;
